import { useAuthStore } from '../../stores/auth'
import colors from '../../colors'
import { Box, Button, Typography, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { TextField } from 'formik-material-ui'
import { Link, useNavigate } from 'react-router-dom'
import * as Yup from 'yup'
import { Formik, Form, Field } from 'formik'
import { toast } from 'react-toastify'

// sx rather than makeStyles: the theme defaults Buttons to contained/uppercase
// and MUI v5's emotion styles override @material-ui/styles v4 classes.
const primaryBtnSx = {
  mt: 3,
  py: 1.25,
  textTransform: 'none',
  fontSize: 15,
  fontWeight: 700,
  borderRadius: '8px',
} as const

const secondaryBtnSx = {
  mt: 1.5,
  py: 1.25,
  textTransform: 'none',
  fontSize: 15,
  fontWeight: 700,
  borderRadius: '8px',
  backgroundColor: colors.WHITE,
  color: colors.STITCH_BLUE,
  borderColor: colors.GREY_4,
  '&:hover': {
    backgroundColor: colors.GREY_7,
    borderColor: colors.GREY_3,
  },
} as const

const LoginForm = () => {
  const styles = useStyles()
  const navigate = useNavigate()
  const { login } = useAuthStore()

  const validationSchema = Yup.object({
    email: Yup.string().required('Required').email(),
    password: Yup.string().required('Required'),
  })
  const defaultErrorMessage = (
    <>
      Somethine went wrong. If this problem persists, please contact Stitch at &nbsp;
      <a href={`mailto:help@stitch.vip`} className={styles.emailLink}>help&amp;stitch.vip</a>
    </>
  )

  const onSubmit = async ({ email, password }: { email: string, password: string }) => {
    try {
      const [success, message] = await login(email, password)
      if (!success) {
        toast.error(message)
      }
    } catch (e) {
      toast.error(defaultErrorMessage)
    }
  }

  return (
    <Formik
      initialValues={{
        email: '',
        password: '',
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formikProps) => {
        return (
          <Box>
            <Typography variant={'h3'}>Login</Typography>
            <Form>
              <Box className={styles.fieldsContainer}>
                <Field
                  autoFocus
                  fullWidth
                  autoCapitalize="none"
                  type="email"
                  label="Email"
                  component={TextField}
                  name="email"
                />
                <Field
                  autoCapitalize="none"
                  fullWidth
                  type="password"
                  label="Password"
                  component={TextField}
                  name="password"
                />
                <Link className={styles.link} to={'/password_reset/request'}>
                  Forgot your password?
                </Link>

                <Button type='submit' fullWidth disableElevation disabled={formikProps.isSubmitting} sx={primaryBtnSx}>
                  {formikProps.isSubmitting ? <CircularProgress size={16} style={{ marginRight: 8 }} /> : null}
                  Sign In
                </Button>

                {/* A real action, not a hint - so a button, not link text. */}
                <Button
                  type='button'
                  fullWidth
                  variant='outlined'
                  disabled={formikProps.isSubmitting}
                  onClick={() => navigate('/signup')}
                  sx={secondaryBtnSx}
                >
                  Create an organization
                </Button>
              </Box>
            </Form>
          </Box>
        )
      }}
    </Formik>
  )
}

const useStyles = makeStyles({
  link: {
    color: colors.BRIGHT_BLUE
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: 400,
    maxWidth: '90vw',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  emailLink: {
    textDecoration: 'underline',
  }
})

export default LoginForm
